import axios from 'axios';
import {LOCAL_STORAGE_AUTH_TOKEN, ResponseCode} from '@app/constants/Common';
import {toast} from 'react-toastify';
import store from '@store/store';
import {logoutUser} from '@store/reducers/auth';
import {Messages} from "@app/constants/Messages";

const service = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

// const dispatch = useDispatch();
// const history = useHistory();

service.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN);
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        // else {
        //     config.headers.Authorization = `Bearer public`;
        // }
        return config;
    },
    (error) => Promise.reject(error)
);

service.interceptors.response.use(
    (response) => {
        // const success = response.data?.meta?.status === 'success';
        // const entity = response.data?.entity;
        // const token = response.data?.entity?.access_token;
        // if (success && token) {
        //     setUserSession(token, {username: entity.login_id});
        // }
        // return response.data;
        console.log(JSON.stringify(response))
        if (response.detail === 'Invalid token.') {
            localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN, "")
            window.location.href = '/login';
        } else if (response.data.sts_code !== ResponseCode.SUCCESS) {
            if (response.data.message) {
                toast.error(response.data.message)
            }

            if (response.data.sts_code === ResponseCode.INVALID_LOGIN_TOKEN) {
                localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN, "")
                store.dispatch(logoutUser());
            }
        }
        return response.data
    },
    (error) => {
        console.log(error)
        if (error.message === 'Network Error') {
            toast.error('Kết nối tới máy chủ không thành công!')
        } else if (error.response.status === 401) {
            localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN, "")
            window.location.href = '/login';
        } else {
            toast.error('Có lỗi xảy ra trong quá trình xử lý!')
        }

        Promise.reject(error)
    }
);

export default service;
